import React, { Component } from 'react';
import {
  FiltersContainer,
  MeterReadingData,
  EmptyStateContainer,
} from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import { connect } from 'react-redux';
import GlobalServices from '../../../../neoverv/helpers/services/GlobalServices';
import MeterIcon from '../../../../assets/images/module/general/blueEmptyMeter.svg';
import { Skeleton } from '@mantine/core';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const MOBILE_SIZE = 992;

export class WEGMeterReadings extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      filteredReadings: [],
      current_billingPeriod_id: '',
      current_billingPeriod: null,
      last_billingPeriod: null,
      billingPeriods: [],
      skeletonLoading: false,
      isMobile: window.innerWidth <= MOBILE_SIZE,
    };
  }

  componentDidMount = () => {
    const { propertySelected } = this.props;
    this._isMounted = true;
    var loader = document.getElementById('hello-housing-loader');
    if (loader) loader.style.display = 'none';
    window.addEventListener('resize', this.handleResize);
    if (propertySelected && propertySelected.id !== undefined) {
      this.setState({ skeletonLoading: true });
      GlobalServices._getWegBilingPeriodsByProperty(
        this,
        '_handleCurrentWegBillingPeriodResponse',
        propertySelected,
        'CurrentWEGBillingPeriod?propertyId='
      );
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  _handleCurrentWegBillingPeriodResponse(response) {
    this.setState({ billingPeriods: [] });
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      const billingPeriod = this._normalizeWegBillingPeriod(response.result, 'current');

      this.setState(
        {
          current_billingPeriod_id: billingPeriod.id,
          billingPeriods: [billingPeriod],
          current_billingPeriod: billingPeriod,
        },
        () => {
          this.setState({
            filteredReadings: [...this.state.filteredReadings, this._toReadingCard(billingPeriod)],
          });

          GlobalServices._getWegBilingPeriodsByProperty(
            this,
            '_handleLastWegBillingPeriodResponse',
            this.props.propertySelected,
            'LastWEGBillingPeriod?propertyId='
          );
        }
      );
    } else {
      GlobalServices._getWegBilingPeriodsByProperty(
        this,
        '_handleLastWegBillingPeriodResponse',
        this.props.propertySelected,
        'LastWEGBillingPeriod?propertyId='
      );
    }
  }

  _handleLastWegBillingPeriodResponse(response) {
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      const billingPeriod = this._normalizeWegBillingPeriod(response.result, 'last');

      this.setState(
        {
          billingPeriods: [...this.state.billingPeriods, billingPeriod],
          least_billingPeriod_id: billingPeriod.id,
          last_billingPeriod: billingPeriod,
        },
        () => {
          this.setState({
            filteredReadings: [...this.state.filteredReadings, this._toReadingCard(billingPeriod)],
          });
          GlobalServices._getWegBilingPeriodsByProperty(this, '_handleWegBillingPeriodResponse', this.props.propertySelected);
        }
      );
    } else {
      GlobalServices._getWegBilingPeriodsByProperty(this, '_handleWegBillingPeriodResponse', this.props.propertySelected);
    }
  }

  _handleWegBillingPeriodResponse(response) {
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      const billingPeriods = response.result.map((period) => this._normalizeWegBillingPeriod(period, 'other'));

      const newFilteredReadingsToAppend = [];
      const newBillingPeriodsToAppend = [];

      billingPeriods.forEach((billingPeriod) => {
        if (
          billingPeriod.id !== this.state.current_billingPeriod_id &&
          billingPeriod.id !== this.state.least_billingPeriod_id
        ) {
          newFilteredReadingsToAppend.push(this._toReadingCard(billingPeriod));
          newBillingPeriodsToAppend.push(billingPeriod);
        }
      });

      if (newFilteredReadingsToAppend.length > 0) {
        this.setState((prevState) => ({
          filteredReadings: [...prevState.filteredReadings, ...newFilteredReadingsToAppend],
          billingPeriods: [...prevState.billingPeriods, ...newBillingPeriodsToAppend],
        }));
      }
    }

    this.ShowLoader();
  }

  // WEG billing period endpoints use startedOn/endedOn (not the regular
  // BillingPeriod endpoints' startDate/endDate) that
  // MeterDataHandler.generateBilingPeriodsObject expects.
  _normalizeWegBillingPeriod(period, type = 'other') {
    return {
      id: Autoload.MainHelper.checkProperty(period, 'id'),
      propertyId: Autoload.MainHelper.checkProperty(period, 'propertyId'),
      startDate: Autoload.MainHelper.checkProperty(period, 'startedOn'),
      endDate: Autoload.MainHelper.checkProperty(period, 'endedOn'),
      type,
    };
  }

  _toReadingCard(billingPeriod) {
    return {
      occupationReadings: [],
      id: billingPeriod.id,
      periodEnd: billingPeriod.endDate,
      periodStart: billingPeriod.startDate,
      billingPeriodData: billingPeriod,
      type: billingPeriod.type,
    };
  }

  ShowLoader = () => {
    this.setState({ skeletonLoading: false });
  };

  render() {
    const { propertySelected } = this.props;
    const { filteredReadings, skeletonLoading, isMobile } = this.state;
    return (
      <div className="meter-reading-section" id="respond-weg-meter-page" style={{ display: 'block' }}>
        <FiltersContainer style={{ marginBottom: isMobile && 0 }} sortElement={null} />
        <div className="divider meter-reading-divider" style={{ marginTop: isMobile && 0 }}></div>
        <div className="data-section">
          {skeletonLoading ? (
            [...Array(5)].map((e, i) => (
              <div key={i}>
                <div style={{ width: '100%', height: '45px', display: 'flex', justifyContent: 'space-between' }}>
                  <Skeleton visible={skeletonLoading} style={{ width: '400px', height: '34px' }} />
                  <Skeleton visible={skeletonLoading} style={{ width: '125px', height: '36px' }} />
                </div>
                <div className="divider" />
              </div>
            ))
          ) : filteredReadings.length > 0 ? (
            <MeterReadingData
              data={filteredReadings}
              parent={this}
              rentalUnitsExist={true}
              propertySelected={propertySelected}
            />
          ) : (
            <EmptyStateContainer
              heading={'WEG-Ablesungen sind noch nicht verfügbar.'}
              subheading={'Legen Sie zunächst einen WEG-Abrechnungszeitraum an, um WEG-Ablesungen durchzuführen.'}
              className="empty-meter-reading"
              icon={MeterIcon}
              showBtn={false}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
  };
};

export default connect(mapStateToProps)(WEGMeterReadings);
